<template>
  <div v-if="title">
    <div class="title" @click="$emit('click')">
      <div>{{ title }}</div>
      <img src="@/assets/next.svg" :class="selectImg(display)" />
    </div>
    <div :class="getClass()">
      <div v-for="(question, questionIndex) in questions" :key="questionIndex">
        <div v-if="question.fields.configuration == null">
          <!-- <div v-for="(choice, choiceIndex) in question.fields.answers.choices" :key="choiceIndex"></div> -->
          <TastingAnswer
            :question="question.fields.answers"
            :value="valueTest(question.fields.answers)"
            @response="handleStatus"
          />
          <div v-if="question.instruction">
            <div
              v-for="content in question.instruction.content"
              :key="content"
              class="instructionItems"
            >
              {{ content.content[0].value }}
            </div>
          </div>
        </div>
        <div
          v-else-if="question.fields.configuration.type == 'speechTransition'"
          class="speechBody"
        >
          {{ question.fields.configuration.data.text }}
        </div>
        <div v-else-if="question.fields.configuration.type == 'tipsTransition'" class="tipsBody">
          <div>{{ question.fields.configuration.data.title }}</div>
          <div
            v-for="(tip, tipIndex) in question.fields.configuration.data.tips"
            :key="tipIndex"
            class="tipsItems"
          >
            <div>{{ tip.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TastingAnswer from '@/components/tasting/TastingAnswer'

export default {
  name: 'questionTasting',
  components: { TastingAnswer },
  props: {
    title: {
      type: String,
      require: true
    },
    display: {
      type: Boolean,
      require: true
    },
    questions: {
      type: Array,
      require: true
    },
    containe: {
      type: Object
    }
  },
  data() {
    return {
      valueRes: null,
      correct: false
    }
  },
  methods: {
    getClass() {
      return this.display ? 'body' : 'bodyNone'
    },
    selectImg(display) {
      return display ? 'img-active' : 'img'
    },
    //return last answer tasting if already done
    valueTest(type) {
      return this.containe.userResponses[this.$route.params.tastingId + '.undefined.' + type.id]
    },
    handleStatus(payload) {
      this.$emit('choice', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
.instructionItems {
  font: normal normal medium 16px/19px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin: 15px;
}
.tipsItems {
  margin: 5px;
}
.speechBody {
  margin: 20px;
  font: normal normal medium 16px/19px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.tipsBody {
  margin: 20px;
  display: flex;
  flex-direction: column;
  font: normal normal medium 16px/19px Montserrat;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.body {
  display: flex;
  flex-direction: column;
  font-size: 18px;
}
.bodyNone {
  display: none;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 13px;
  align-items: center;
  background-color: $primary;
  padding: 12px;
  font-size: 20px;
  font-weight: 700;
  color: $font-banner;
  cursor: pointer;
  .img {
    height: 30px;
    width: 30px;
  }
  .img-active {
    height: 30px;
    width: 30px;
    transform: rotate(90deg);
  }
}
</style>
